import React from 'react';
import { Container, Title, Subtitle, Button } from './Styled';

export const ModalSheetError = ({ backToForm }: { backToForm: () => void }) => (
  <Container>
    <Title>Poxa, aconteceu um problema</Title>
    <Subtitle>Mas você pode tentar enviar sua pergunta de novo, tá?</Subtitle>
    <Button onClick={backToForm}>Tentar de novo</Button>
  </Container>
);

export default ModalSheetError;
